import React from 'react';
import { Info, CheckCircle, AlertTriangle, XCircle } from 'lucide-react';
import '../../styles/design-system.css';

/**
 * Alert Component
 * Alert/notification box matching iLovePDF design
 * 
 * @param {Object} props
 * @param {string} props.variant - 'info' | 'success' | 'warning' | 'error'
 * @param {string} props.title - Alert title
 * @param {React.ReactNode} props.children - Alert content
 * @param {boolean} props.dismissible - Show close button
 * @param {Function} props.onDismiss - Dismiss callback
 */
const Alert = ({
    variant = 'info',
    title,
    children,
    dismissible = false,
    onDismiss,
    className = ''
}) => {
    const icons = {
        info: Info,
        success: CheckCircle,
        warning: AlertTriangle,
        error: XCircle
    };

    const Icon = icons[variant];

    const classes = [
        'alert',
        `alert-${variant}`,
        className
    ].filter(Boolean).join(' ');

    return (
        <div className={classes}>
            <Icon size={20} style={{ flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
                {title && (
                    <div style={{
                        fontWeight: 'var(--font-semibold)',
                        marginBottom: 'var(--spacing-1)'
                    }}>
                        {title}
                    </div>
                )}
                <div>{children}</div>
            </div>
            {dismissible && onDismiss && (
                <button
                    onClick={onDismiss}
                    className="btn btn-ghost btn-sm btn-icon"
                    style={{ marginLeft: 'var(--spacing-2)' }}
                >
                    <XCircle size={16} />
                </button>
            )}
        </div>
    );
};

export default Alert;
